import React, { useState, useEffect, useRef } from "react";
import { CryptoType } from "../interface";
import { formatCurrency } from "../utils/format-utils";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";

type CryptoCardProps = {
  item: CryptoType;
  value: number;
  isAnimating: boolean;
};

export const CryptoCard: React.FC<CryptoCardProps> = ({
  item,
  value,
  isAnimating,
}) => {
  const [displayValue, setDisplayValue] = useState(value);
  const frames = useRef<any>([]);
  const frameIndex = useRef(0);

  const handleLinkClick = async (url: string) => {
    if (url !== "") {
      window.open(url, "_blank");
    }
  };
  /*
  useEffect(() => {
    if (isAnimating) {
      // Generate animation frames
      frames.current = Array.from({ length: 10 }, () =>
        (Math.random() * value * 1.5).toFixed(2),
      );
      frames.current.push(value);

      frameIndex.current = 0;
      const interval = setInterval(() => {
        if (frameIndex.current < frames.current.length) {
          setDisplayValue(frames.current[frameIndex.current]);
          frameIndex.current++;
        } else {
          clearInterval(interval);
        }
      }, 80);

      return () => clearInterval(interval);
    }
  }, [isAnimating, value]);
*/
  return (
    <>
      <style>
        {`
                .hot-name-${item.cid}::after {
                    content: "${item.symbol.toUpperCase()}";
                }
                `}
      </style>
      <div className={"nft hot-name-" + item.cid + " hot-badge"}>
        <div className="main">
          <img
            className="tokenImage"
            src={"/images/crypto/" + item.symbol + ".png"}
            alt={item.name}
          />
          <h2
            className={`transition-all duration-100 ${false ? "scale-110 text-green-500 font-bold" : ""}`}
          >
            {formatCurrency(displayValue)}
            {item.platforms[0].trend >= 0 ? (
              <ArrowUpwardRoundedIcon
                className={"high_arrow"}
              ></ArrowUpwardRoundedIcon>
            ) : (
              <ArrowDownwardRoundedIcon
                className={"low_arrow"}
              ></ArrowDownwardRoundedIcon>
            )}
          </h2>
          <hr />
          {item.platforms.map((pf, index) => {
            const isFirst = index === 0;
            const isLast = index === item.platforms.length - 1;
            return (
              <div
                key={index}
                className="flex justify-between items-center cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick(pf.url);
                }}
              >
                <div className="creator">
                  <div className="wrapper">
                    <img
                      src={"/images/exchange/" + pf.name.toLowerCase() + ".png"}
                      alt={pf.name}
                    />
                  </div>
                  <ins
                    style={{
                      color: isFirst ? "#63f700" : isLast ? "#e4002c" : "white",
                    }}
                  >
                    {pf.name}
                  </ins>
                </div>
                <p
                  style={{
                    color: isFirst ? "#63f700" : isLast ? "#e4002c" : "white",
                  }}
                >
                  {formatCurrency(pf.price)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
